import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '@app/components/atoms/svg-icon/svg-icon.module';
import { InputIconComponent } from './input-icon.component';
import { InputModule } from '../../atoms/input/input.module';

@NgModule({
  declarations: [InputIconComponent],
  imports: [CommonModule, SvgIconModule, InputModule],
  exports: [InputIconComponent],
})
export class InputIconModule {}
